import React, { useEffect } from "react";
import EnlistNewDroneHero from "../components/enlistNewDronePage/EnlistNewDroneHero";
 
import Navbar from "../components/homepage/Navbar";
import EnlishNewDrone from "../components/enlistNewDronePage/EnlishNewDrone";
import EnlishNewDroneHero from "../components/enlistNewDronePage/EnlishNewDroneHero";
import WhyNewDrone from "../components/enlistNewDronePage/WhyNewDrone";
import { Header, Footer } from "../shared";

const EnlistNewDronePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      {/* <EnlistNewDroneHero /> */}
      {/* <EnlishNewDroneHero /> */}
      {/* <WhyNewDrone /> */}
      <EnlishNewDrone />
      <Footer />
    </div>
  );
};

export default EnlistNewDronePage;
